module.exports = __webpack_public_path__ + "media/bgm.d0ef919f.mp3";